import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import authorizationService from '../common/services/security/authorizationService';
import ProjectDetails from '../features/project/ViewProject/ProjectDetails';
import CreateProject from '../features/project/CreateProject/CreateProject'; // TODO: Remove use of Beta
import PrivateRoute from '../features/security/PrivateRoute';
import NonProjectContentRouter from './NonProjectContentRouter';
import { getUserTermsAndConditionsHasAccepted } from '../common/redux/userTermsAndConditions/userTermsAndConditionsSlice';
import { getFakeClientUser } from '../common/redux/security/loggedInUser/loggedInUserSlice';

const ContentRouter = () => {
  const isFakeClientUser = useSelector(getFakeClientUser);
  const tAndCHasAccepted = useSelector(getUserTermsAndConditionsHasAccepted);

  return (
    <Switch>
      {authorizationService.canCreateProjects() && !isFakeClientUser && (
        <PrivateRoute
          exact
          path="/projects/create-project"
          component={CreateProject}
          tAndCHasAccepted={tAndCHasAccepted}
        />
      )}
      <PrivateRoute
        path="/projects/:projectId"
        component={ProjectDetails}
        tAndCHasAccepted={tAndCHasAccepted}
      />
      <Route>
        <NonProjectContentRouter />
      </Route>
    </Switch>
  );
};

export default ContentRouter;
